/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-31 10:21:40
 *
 *******************************************************/
//flow
import React, { Component } from 'react';
import { Modal, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  loading: boolean,
  handleSwitch: Function,
  handleCancel: Function
};

type ComposedProps = Props & WithI18nProps;

class UpgradeSearchVersionModal extends Component<ComposedProps> {
  render() {
    const { active, i18n, loading, handleUpgrade } = this.props;

    return (
      <Modal
        open={active}
        onClose={this.handleCancel}
        title={i18n.translate('AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.title')}
        primaryAction={{
          content: i18n.translate(
            'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.action'
          ),
          loading: loading,
          onAction: handleUpgrade
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleCancel
          }
        ]}>
        <Modal.Section>
          <div>
            <p>
              {i18n.translate(
                'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.paragraph01',
                {
                  t1: (
                    <TextStyle variation="strong">
                      {i18n.translate(
                        'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.paragraph01_t1'
                      )}
                    </TextStyle>
                  )
                }
              )}
            </p>
            <p style={{ marginTop: '24px' }}>
              {i18n.translate(
                'AdminHTML.InstantSearchDisplay.UpgradeSearchVersionModal.paragraph02'
              )}
            </p>
          </div>
        </Modal.Section>
      </Modal>
    );
  }

  handleCancel = () => {
    this.props.handleCancel();
  };
}

export default withI18n()(UpgradeSearchVersionModal);
